module.exports = __webpack_public_path__ + "img/South-Ossetia.46dffb82.png";